module.exports = __webpack_public_path__ + "img/icon-locatives_hover.a4b8e50d.svg";